const RemoteConfigDefaults = {
  test: ''
};

export default RemoteConfigDefaults;
